module.exports = "<div class=\"toolTip {{align}}\" ng-class=\"{'displayInline': displayInline, 'balloon': !displayInline}\" ng-transclude role=\"tooltip\" id=\"{{toolTipID}}\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../~/noop-loader!./components/xo-ui-components/src/tooltip/template.html
// module id = ../node_modules/noop-loader/index.js!./components/xo-ui-components/src/tooltip/template.html
// module chunks = 1